var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "500px" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-form",
        { ref: "form" },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [_vm._v("Edit Location Name")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("p", [
                    _vm._v(
                      "\n          Enter a new display name, or select an existing alias to become the primary name.\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-combobox", {
                    ref: "displayNameInput",
                    attrs: {
                      solo: "",
                      label: "Location Name",
                      items: _vm.aliasItems,
                      "item-text": "name",
                      "item-value": "name",
                      rules: [_vm.rules.required],
                      "persistent-hint": "",
                      hint: "Locations with identical names are treated as separate locations.",
                      "return-object": false,
                    },
                    model: {
                      value: _vm.formObject.DisplayName,
                      callback: function ($$v) {
                        _vm.$set(_vm.formObject, "DisplayName", $$v)
                      },
                      expression: "formObject.DisplayName",
                    },
                  }),
                  _vm._v(" "),
                  _vm.isSystemAdmin
                    ? [
                        _c("v-subheader", { staticClass: "pl-0" }, [
                          _vm._v("System Administrator Settings"),
                        ]),
                        _vm._v(" "),
                        _c("v-checkbox", {
                          staticClass: "mt-0",
                          attrs: {
                            color: "info",
                            label: "Make primary name",
                            "persistent-hint": "",
                            hint: "New synonym will become the primary name of all data sources",
                          },
                          model: {
                            value: _vm.formObject.data.makePrimary,
                            callback: function ($$v) {
                              _vm.$set(_vm.formObject.data, "makePrimary", $$v)
                            },
                            expression: "formObject.data.makePrimary",
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "v-alert",
                {
                  key: "alert",
                  staticClass: "my-0",
                  attrs: {
                    outline: "",
                    type: "warning",
                    value: !_vm.formObject.data.makePrimary,
                  },
                },
                [
                  _c("div", { staticClass: "primary--text" }, [
                    _vm._v(
                      "\n          The data source alias shows up in reports, which may cause confusion when the primary alias does not match\n          the\n          location name.\n        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success", loading: _vm.loading.submit },
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                      _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { depressed: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }